import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { Grid } from "@mui/joy";

import { Textarea, TextField, Autocomplete, UserDropdown, LeadSourceDropdown, Checkbox } from "../../../../shared";

export function BasicDetails() {
    const { watch, setValue } = useFormContext();
    const hasSecondarySalesman = watch("hasSecondarySalesman");

    useEffect(() => {
        if (!hasSecondarySalesman) {
            setValue("secondarySalesmanName", "");
        }
    }, [hasSecondarySalesman, setValue]);

    return (
        <Grid container spacing={2} mt={0}>
            <Grid xs={12}>
                <TextField
                    label={"Name"}
                    helperText={"Name of the project"}
                    placeholder={"My Villa Roofing"}
                    name={"name"}
                />
            </Grid>
            <Grid xs={12}>
                <Textarea
                    label={"Description"}
                    helperText={"Project summary"}
                    placeholder={"Details"}
                    name={"description"}
                />
            </Grid>
            <Grid xs={6}>
                <Autocomplete
                    options={["Residential", "Commercial", "Industrial", "Multifamily"]}
                    label={"Type"}
                    placeholder={"e.g., Residential, Commercial"}
                    helperText={"Select the project category"}
                    name={"type"}
                />
            </Grid>
            <Grid xs={6}>
                <LeadSourceDropdown
                    label={"Primary Lead Source"}
                    placeholder={"Select primary lead source"}
                    helperText={"Primary lead source (e.g., Social Media, Website Signup)"}
                    name={"leadSource"}
                />
            </Grid>
            <Grid xs={6}>
                <TextField
                    label={"Secondary Lead Source"}
                    placeholder={"Enter secondary lead source"}
                    helperText={"Optional: Person or company who brought this lead"}
                    name={"secondaryLead"}
                />
            </Grid>
            <Grid xs={6}>
                <UserDropdown
                    label={"Salesman Name"}
                    placeholder={"Select salesman"}
                    helperText={"Assigned sales representative"}
                    name={"salesmanName"}
                />
            </Grid>
            <Grid xs={6} display={"flex"} alignItems={"flex-end"}>
                <Checkbox
                    name={"hasSecondarySalesman"}
                    label={"Enable secondary salesman"}
                    size="sm"
                    helperText={"Toggle to assign a secondary sales representative."}
                />
            </Grid>
            {hasSecondarySalesman && (
                <Grid xs={6}>
                    <TextField
                        label={"Secondary Salesman Name"}
                        placeholder={"Enter secondary salesman name"}
                        helperText={"An additional sales representative"}
                        name={"secondarySalesmanName"}
                    />
                </Grid>
            )}
        </Grid>
    );
}
